import * as fromDatatype from '../datatype-library';

export interface bl_alg_cc_template_message_placeholder_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  template_message_hdr_guid: fromDatatype.GuidDataFieldInterface;
  template_message_line_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  placeholder_name: fromDatatype.VarcharDatatypeInterface;
  placeholder_code: fromDatatype.VarcharDatatypeInterface;
  placeholder_type: fromDatatype.VarcharDatatypeInterface;
  placeholder_source: fromDatatype.VarcharDatatypeInterface;
  placeholder_data_type: fromDatatype.VarcharDatatypeInterface;
  default_value: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  index: fromDatatype.IntegerDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_alg_cc_template_message_placeholder_hdr_RowClass
  implements bl_alg_cc_template_message_placeholder_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  template_message_hdr_guid: fromDatatype.GuidDataFieldInterface;
  template_message_line_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  placeholder_name: fromDatatype.VarcharDatatypeInterface;
  placeholder_code: fromDatatype.VarcharDatatypeInterface;
  placeholder_type: fromDatatype.VarcharDatatypeInterface;
  placeholder_source: fromDatatype.VarcharDatatypeInterface;
  placeholder_data_type: fromDatatype.VarcharDatatypeInterface;
  default_value: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  index: fromDatatype.IntegerDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
